import { BedayaAction } from '../../types/BedayaAction';
import { GlsSettings } from '../../types/GlsSettings';
import { GET_SETTINGS, PUT_SETTINGS } from '../actions/common_actions';

export interface IGlsState {
  settings: GlsSettings;
  isFetching: boolean;
  error: any;
}

const initialState: IGlsState = {
  settings: {
    enabled: false,
    countries: [],
  },
  isFetching: false,
  error: '',
};

export default function reducer(state: IGlsState = initialState, action: BedayaAction): IGlsState {
  switch (action.type) {
    case GET_SETTINGS.REQUEST:
    case PUT_SETTINGS.REQUEST:
      if (['gls'].includes(action.data.system)) {
        return {
          ...state,
          isFetching: true,
        };
      }
      return state;
    case PUT_SETTINGS.SUCCESS:
      if (['gls'].includes(action.data.system)) {
        return {
          ...state,
          settings: action.data.data,
          isFetching: false,
        };
      }
      return state;
    case GET_SETTINGS.SUCCESS:
      if (['gls'].includes(action.data.system)) {
        return {
          ...state,
          settings: action.data.data,
          isFetching: false,
        };
      }
      return state;
    default:
      return state;
  }
}
